(function() {
  function getDrawerIdFromTrigger(trigger) {
    return trigger.getAttribute('data-wc-filter-open');
  }

  function setDrawerState(drawerId, isOpen) {
    var drawer = document.querySelector('[data-wc-filter-drawer="' + drawerId + '"]');
    var openButtons = document.querySelectorAll('[data-wc-filter-open="' + drawerId + '"]');
    var panel = drawer ? drawer.querySelector('.wc-filter-drawer__panel') : null;

    if (!drawer) return;

    drawer.hidden = !isOpen;
    document.documentElement.classList.toggle('wc-filter-drawer-open', isOpen);

    openButtons.forEach(function(button) {
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    if (isOpen && panel) {
      panel.focus({ preventScroll: true });
    }
  }

  function initCollectionFacets(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-wc-filter-open]').forEach(function(button) {
      if (button.dataset.wcBound === 'true') return;

      button.dataset.wcBound = 'true';

      button.addEventListener('click', function() {
        setDrawerState(getDrawerIdFromTrigger(button), true);
      });
    });

    scope.querySelectorAll('[data-wc-filter-close]').forEach(function(button) {
      if (button.dataset.wcBound === 'true') return;

      button.dataset.wcBound = 'true';

      button.addEventListener('click', function() {
        setDrawerState(button.getAttribute('data-wc-filter-close'), false);
      });
    });

    scope.querySelectorAll('[data-wc-auto-submit]').forEach(function(form) {
      if (form.dataset.wcAutoBound === 'true') return;

      form.dataset.wcAutoBound = 'true';

      form.addEventListener('change', function(event) {
        if (event.target && event.target.matches('input[type="checkbox"], input[type="radio"], select')) {
          form.submit();
        }
      });
    });
  }

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('.wc-filter-drawer:not([hidden])').forEach(function(drawer) {
      setDrawerState(drawer.getAttribute('data-wc-filter-drawer'), false);
    });
  });

  document.addEventListener('click', function(event) {
    document.querySelectorAll('.wc-quick-filter[open]').forEach(function(details) {
      if (!details.contains(event.target)) {
        details.removeAttribute('open');
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCollectionFacets(document);
    });
  } else {
    initCollectionFacets(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initCollectionFacets(event.target || document);
  });
 function initPriceSliders(root) {
  var scope = root || document;

  scope.querySelectorAll('[data-wc-price-slider]').forEach(function(slider) {
    if (slider.dataset.wcPriceBound === 'true') return;
    slider.dataset.wcPriceBound = 'true';

    var minRange = slider.querySelector('[data-wc-price-min-range]');
    var maxRange = slider.querySelector('[data-wc-price-max-range]');
    var minField = slider.querySelector('[data-wc-price-min-field]');
    var maxField = slider.querySelector('[data-wc-price-max-field]');
    var minText = slider.querySelector('[data-wc-price-current-min]');
    var maxText = slider.querySelector('[data-wc-price-current-max]');
    var fill = slider.querySelector('[data-wc-price-fill]');

    if (!minRange || !maxRange || !minField || !maxField || !fill) return;

    var minLimit = Number(slider.dataset.min || 0);
    var maxLimit = Number(slider.dataset.max || maxRange.max || 0);

    function clampValues(changed) {
      var minValue = Number(minRange.value || minLimit);
      var maxValue = Number(maxRange.value || maxLimit);

      if (minValue > maxValue) {
        if (changed === 'min') {
          minValue = maxValue;
          minRange.value = minValue;
        } else {
          maxValue = minValue;
          maxRange.value = maxValue;
        }
      }

      var minPercent = maxLimit > minLimit ? ((minValue - minLimit) / (maxLimit - minLimit)) * 100 : 0;
      var maxPercent = maxLimit > minLimit ? ((maxValue - minLimit) / (maxLimit - minLimit)) * 100 : 100;

      fill.style.left = minPercent + '%';
      fill.style.right = (100 - maxPercent) + '%';

      if (minText) minText.textContent = minValue;
      if (maxText) maxText.textContent = maxValue;

      minField.value = minValue <= minLimit ? '' : minValue;
      maxField.value = maxValue >= maxLimit ? '' : maxValue;
    }

    minRange.addEventListener('input', function() {
      clampValues('min');
    });

    maxRange.addEventListener('input', function() {
      clampValues('max');
    });

    minField.addEventListener('input', function() {
      var value = Number(minField.value || minLimit);
      value = Math.max(minLimit, Math.min(value, maxLimit));
      minRange.value = value;
      clampValues('min');
    });

    maxField.addEventListener('input', function() {
      var value = Number(maxField.value || maxLimit);
      value = Math.max(minLimit, Math.min(value, maxLimit));
      maxRange.value = value;
      clampValues('max');
    });

    clampValues();
  });
}

initPriceSliders(document);

document.addEventListener('shopify:section:load', function(event) {
  initPriceSliders(event.target || document);
}); 
})();

(function() {
  function isMobileProductGrid() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function setProductViewButtons(view) {
    document.querySelectorAll('[data-wc-product-view]').forEach(function(button) {
      var isActive = button.getAttribute('data-wc-product-view') === String(view);
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function applyProductGridView(view) {
    var grid = document.querySelector('[data-wc-product-grid]');
    if (!grid) return;

    grid.classList.remove('is-desktop-4', 'is-desktop-3', 'is-mobile-2', 'is-mobile-1');

    if (isMobileProductGrid()) {
      if (String(view) === '1') {
        grid.classList.add('is-mobile-1');
        localStorage.setItem('wcProductMobileView', '1');
        setProductViewButtons('1');
      } else {
        grid.classList.add('is-mobile-2');
        localStorage.setItem('wcProductMobileView', '2');
        setProductViewButtons('2');
      }
    } else {
      if (String(view) === '3') {
        grid.classList.add('is-desktop-3');
        localStorage.setItem('wcProductDesktopView', '3');
        setProductViewButtons('3');
      } else {
        grid.classList.add('is-desktop-4');
        localStorage.setItem('wcProductDesktopView', '4');
        setProductViewButtons('4');
      }
    }
  }

  function initProductGridSwitch(root) {
    var scope = root || document;
    var switcher = scope.querySelector('[data-wc-product-view-switch]');
    var grid = document.querySelector('[data-wc-product-grid]');

    if (!switcher || !grid) return;
    if (switcher.dataset.wcProductViewBound === 'true') return;

    switcher.dataset.wcProductViewBound = 'true';

    var savedDesktopView = localStorage.getItem('wcProductDesktopView') || '4';
    var savedMobileView = localStorage.getItem('wcProductMobileView') || '2';

    applyProductGridView(isMobileProductGrid() ? savedMobileView : savedDesktopView);

    switcher.querySelectorAll('[data-wc-product-view]').forEach(function(button) {
      button.addEventListener('click', function() {
        applyProductGridView(button.getAttribute('data-wc-product-view'));
      });
    });

    window.addEventListener('resize', function() {
      var currentDesktopView = localStorage.getItem('wcProductDesktopView') || '4';
      var currentMobileView = localStorage.getItem('wcProductMobileView') || '2';

      applyProductGridView(isMobileProductGrid() ? currentMobileView : currentDesktopView);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initProductGridSwitch(document);
    });
  } else {
    initProductGridSwitch(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initProductGridSwitch(event.target || document);
  });
})();
(function() {
  function initLoadMore(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-wc-load-more]').forEach(function(button) {
      if (button.dataset.wcLoadMoreBound === 'true') return;
      button.dataset.wcLoadMoreBound = 'true';

      button.addEventListener('click', function() {
        var nextUrl = button.getAttribute('data-next-url');
        var label = button.getAttribute('data-label') || 'Load more';
        var loadingLabel = button.getAttribute('data-loading-label') || 'Loading...';
        var text = button.querySelector('[data-wc-load-more-text]');
        var currentGrid = document.querySelector('[data-wc-product-grid]');
        var currentPagination = document.querySelector('[data-wc-pagination]');

        if (!nextUrl || !currentGrid) return;

        button.disabled = true;
        button.classList.add('is-loading');

        if (text) {
          text.textContent = loadingLabel;
        }

        fetch(nextUrl, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(function(response) {
            if (!response.ok) {
              throw new Error('Load more request failed');
            }

            return response.text();
          })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var nextGrid = doc.querySelector('[data-wc-product-grid]');
            var nextPagination = doc.querySelector('[data-wc-pagination]');
            var nextButton = doc.querySelector('[data-wc-load-more]');

            if (!nextGrid) {
              throw new Error('Next product grid not found');
            }

            Array.prototype.slice.call(nextGrid.children).forEach(function(item) {
              currentGrid.appendChild(document.importNode(item, true));
            });

            if (currentPagination && nextPagination) {
              currentPagination.innerHTML = nextPagination.innerHTML;
            }

            if (nextButton && nextButton.getAttribute('data-next-url')) {
              button.setAttribute('data-next-url', nextButton.getAttribute('data-next-url'));
              button.disabled = false;
              button.classList.remove('is-loading');

              if (text) {
                text.textContent = label;
              }
            } else {
              button.remove();
            }
          })
          .catch(function() {
            button.disabled = false;
            button.classList.remove('is-loading');

            if (text) {
              text.textContent = label;
            }

            window.location.href = nextUrl;
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initLoadMore(document);
    });
  } else {
    initLoadMore(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initLoadMore(event.target || document);
  });
})();
/**
 * Close collection filter/sort dropdowns on outside click.
 * Works for desktop collection/search dropdowns based on <details>.
 */
(function () {
  const dropdownSelector = [
    '.wc-collection-main details.wc-filter-group[open]',
    '.wc-collection-main details.filter-group[open]',
    '.wc-search-main details.wc-filter-group[open]',
    '.wc-search-main details.filter-group[open]',
    '.wc-collection-toolbar details[open]',
    '.wc-collection-toolbar__sort[open]',
    '.wc-filter-group--sort[open]'
  ].join(',');

  function getOpenDropdowns() {
    return Array.from(document.querySelectorAll(dropdownSelector)).filter((details) => {
      return !details.closest('.wc-filter-drawer');
    });
  }

  function closeDropdown(details) {
    if (!details) return;
    details.removeAttribute('open');
  }

  document.addEventListener('click', function (event) {
    const openDropdowns = getOpenDropdowns();

    if (!openDropdowns.length) return;

    openDropdowns.forEach((details) => {
      if (!details.contains(event.target)) {
        closeDropdown(details);
      }
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    getOpenDropdowns().forEach(closeDropdown);
  });

  document.addEventListener('shopify:section:load', function () {
    getOpenDropdowns().forEach(closeDropdown);
  });
})();